<template>
  <div class="draw">
    <AppNavbar v-if="isApp" :options="options" :zIndex="0"> </AppNavbar>
    <div class="bg-desc">
      <div>诸事不顺？一键抽签解水逆</div>
    </div>
    <div class="download" v-if="!isApp">
      <img
        class="logo"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e93143f47e6418437ba209310fb2f306.png"
        alt=""
      />
      <div class="center">
        <div class="text1">betterWE星球</div>
        <div class="text2">一站式真人营养师服务平台</div>
      </div>
      <div class="btn">
        <span>打开看看</span>
        <WxOpenLaunchApp :extinfo="extinfo" sfrom="APP_CQHD"></WxOpenLaunchApp>
      </div>
    </div>
    <div v-if="cardData" style="overflow: hidden">
      <img
        class="app-logo"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-ques-logo"
        alt=""
      />
      <div class="btn-list" v-if="isApp">
        <div
          class="btn-item"
          @click="bindShare"
          v-buried
          v-clickBuried
          data-click-buried="CLICK_CQHD_ZYFX"
          data-buried="BG_CQHD_ZYFX"
          ><span class="iconfont icon-share1"></span><span>分享</span></div
        >
        <div class="btn-item" @click="bindRule"
          ><span class="iconfont icon-help"></span><span>规则</span></div
        >
      </div>
      <div class="draw-content">
        <div
          class="draw-btn"
          @click="bindDraw"
          v-buried
          v-clickBuried
          data-click-buried="CLICK_CQHD_LJCQ"
          data-buried="BG_CQHD_LJCQ"
        >
          <WxOpenLaunchApp
            :extinfo="extinfo"
            sfrom="APP_CQHD"
          ></WxOpenLaunchApp>
          <div class="draw-count">
            <div class="draw-count-text"
              >抽签次数：{{ cardData.used_times }}/{{ cardData.get_times }}</div
            >
          </div>
          <div class="draw-text">立即抽签</div>
          <img
            class="draw-btn-image"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c1f9f39cc12d91efccb5a11b2f591d40.png"
            alt=""
          />
        </div>
        <div class="tip">分享活动每日可多得{{ canGetCount }}次抽奖机会</div>
      </div>
      <div class="c-container">
        <div class="c-title"
          ><span class="c-line"></span><span class="c-dot"></span
          ><span>我的上上签</span><span class="c-dot"></span
          ><span class="c-line"></span
        ></div>
        <CardList
          :cardList="cardData.themes"
          @preview="getResultList"
          :extinfo="extinfo"
          :isApp="isApp"
        />
      </div>
      <ResultComponent
        v-model="showResult"
        :isResultType="isResultType"
        :index="resultIndex"
        @change="bindCardChange"
        @share="bindShareResult"
        :data="resultData"
      />
      <div class="loading">
        <van-overlay :show="loadingResult">
          <div class="wrapper">
            <!-- <img class="draw-animate"
                            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f37d6b536bdca276c035003d886f5361.gif"
                            alt=""> -->
            <DrawAnimate
              ref="drawAnimate"
              class="draw-animate"
              url="https://gymvue.gymcity.com.cn/json/draw-animate1.json"
            />
          </div>
        </van-overlay>
      </div>
      <!-- 暂无抽签次数 -->
      <van-overlay :show="showShareToast" @click="showShareToast = false">
        <div class="toast-wrapper" @click.stop>
          <div class="animate__animated animate__bounceIn">
            <img
              class="image"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f2ca7eb4d6a3f28465acfdd389ab232f.png"
              alt=""
            />
            <div class="t-tips">
              <div class="t-desc">分享活动给好友可获取次数</div>
              <div class="t-day"
                ><span>每日</span><span class="color">限2次</span></div
              >
            </div>
            <div
              class="t-share-btn"
              @click="bindClickToastShare"
              v-buried
              v-clickBuried
              data-click-buried="CLICK_CQHD_CSBZ"
              data-buried="BG_CQHD_CSBZ"
              >去分享</div
            >
          </div>
        </div>
      </van-overlay>
      <!-- 规则 -->
      <van-overlay :show="showRule" @click="bindCloseRule">
        <DrawRule @close="bindCloseRule" />
      </van-overlay>
      <!-- 分享卡片 -->
      <van-overlay
        :show="showShareCard"
        @click="bindCloseShareCard"
        :lock-scroll="false"
        z-index="3000"
      >
        <ShareCard
          v-if="showShareCard"
          :data="shareCardData"
          @save="bindSaveCard"
          @share="bindShareCard"
          @close="bindShareClose"
        />
      </van-overlay>
      <!-- 分享组件 -->
      <ShareComponent
        v-model="showShare"
        :options="iconList"
        @cancel="bindCancel"
        @select="bindSelect"
        :qrcodeUrl="qrcodeUrl"
      />
    </div>
  </div>
</template>
<script>
import AppNavbar from '@/components/app/nav-bar/index.vue'
import ShareCard from './components/share-card.vue'
import WxOpenLaunchApp from '@/components/wx/wx-open-app.vue'
import DrawAnimate from './components/draw-animate.vue'
import { eventObj } from '@/components/app/share/share-method.js'
import CardList from './components/card-list.vue'
import ResultComponent from './components/result.vue'
import AppLoading from '@/components/app/loading/loading.vue'
import ShareComponent from '@/components/app/share/share.vue'
import DrawRule from './components/rule.vue'
export default {
  components: {
    ResultComponent,
    CardList,
    AppLoading,
    ShareComponent,
    DrawRule,
    DrawAnimate,
    WxOpenLaunchApp,
    AppNavbar,
    ShareCard
  },
  data() {
    return {
      options: {
        barBackgroundColor: 'transparent'
      },
      isApp: true,
      extinfo: '',
      resultIndex: 0,
      showResult: false,
      isResultType: false,
      drawCount: 0,
      drawTotal: 3,
      resultData: [],
      cardData: null,
      iconList: [
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon2',
          name: '微信好友',
          id: 1
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon3',
          name: '朋友圈',
          id: 2
        }
        /*  {
                     icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon4',
                     name: '复制链接',
                     id: 3,
                     copy: true,
                     className: "share-copy-btn",
                 } */
      ],
      showRule: false,
      loadingResult: false,
      showShare: false, //显示分享
      qrcodeUrl: '', //分享链接
      showShareToast: false,
      shareOptions: {
        //分享参数
        url: '',
        desc: '拒绝水逆，抽签得好运',
        title: '在求人和求己中，我选择了求签',
        thumbnail:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-share-image'
      },
      shareCardData: null,
      showShareCard: false
    }
  },
  computed: {
    canGetCount() {
      if (this.cardData) {
        return this.cardData.max_times - 1
      } else {
        return 0
      }
    }
  },
  created() {
    //未登录
    this.$betterwe.isLogin(() => {
      this.getData()
    })
    this.isApp = this.$http._isApp()
    this.qrcodeUrl = location.origin + location.pathname
    let url = location.origin + location.pathname
    this.extinfo = '/web?url=' + encodeURIComponent(url)
    this.getData()
  },
  methods: {
    bindRule() {
      this.showRule = true
    },
    bindCloseRule() {
      this.showRule = false
    },
    bindCloseShareCard() {
      this.showShareCard = false
    },
    bindShare() {
      this.shareType = 1
      this.shareId = 0
      this.showShare = true
    },
    bindShareResult(item) {
      this.shareCardData = item
      this.showShareCard = true
    },
    bindSaveCard(url) {
      this.$betterwe.onAppSaveImage({ data: url })
    },
    bindShareCard(item) {
      let shareOptions = Object.assign({}, this.shareOptions)
      shareOptions.url = item.share
      eventObj.shareImageUrlToWxFriend(shareOptions)
      this.shareType = 2
      this.shareId = item.id
      this.getShareCount()
    },
    bindShareClose() {
      this.showShareCard = false
    },
    bindCancel() {
      this.showShare = false
    },
    async bindSelect(options) {
      this.showShare = false
      let shareOptions = Object.assign({}, this.shareOptions)
      this.getShareCount()
      switch (options.id) {
        // 分享链接到微信好友
        case 1:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxFriend(shareOptions)
          break
        // 分享链接到微信朋友圈
        case 2:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxCircle(shareOptions)
          break
        // 分享图片到微信好友 图片 -> base64
        case 3:
          break
      }
    },
    getData() {
      let url = this.isApp
        ? 'api/v1/LotteryActivity/index'
        : 'api/v1/LotteryActivity/visitorIndex'
      this.$http.getApp(url, {}).then((res) => {
        res = res.data
        if (res.code == 200) {
          /* 初始化卡片动画状态 */
          res.data.themes.map((item) => {
            item.animate = false
            item.resultList = []
            let obj = res.data.not_reads.find((item1) => {
              return item1.theme_id == item.theme_id
            })
            item.addNum = (obj && obj.not_read_num) || 0
          })
          this.cardData = res.data
          /*   this.getDrawLocalstorage(); */
        } else {
          this.$toast(res.msg)
        }
      })
    },
    /* 点击弹框中的分享按钮 */
    bindClickToastShare() {
      this.shareType = 1
      this.shareId = 0
      this.showShareToast = false
      this.showShare = true
    },
    bindCardChange(index) {
      if (this.cardData.themes[index].animate) {
        this.$toast('点的太快啦')
        return
      }
      if (this.notRead) {
        this.cardData.themes[index].addNum = this.notRead.not_read_num
      }
      this.cardData.themes[index].animate = true
      this.cardData.themes[index].draw_num++
      setTimeout(() => {
        this.cardData.themes[index].animate = false
      }, 600)
    },
    getShareCount() {
      if (
        this.cardData.used_times >= this.cardData.max_times ||
        this.cardData.get_times >= this.cardData.max_times
      ) {
        return
      }
      let params = {
        type: this.shareType,
        ref_id: this.shareId
      }
      this.$http.postApp('api/v1/LotteryActivity/share', params).then((res) => {
        res = res.data
        if (res.code == 200) {
          this.cardData.get_times++
        }
      })
    },
    getResultList(id) {
      let index = this.cardData.themes.findIndex((item) => {
        return item.theme_id == id
      })
      this.cardData.themes[index].addNum = 0
      this.resultIndex = index
      if (
        this.cardData.themes[index].resultList &&
        this.cardData.themes[index].resultList.length
      ) {
        this.resultData = this.cardData.themes[index].resultList
        this.isResultType = false
        this.showResult = true
        this.readDraw(id, this.cardData.themes[index].resultList)
      } else {
        this.$http
          .getApp('api/v1/LotteryActivity/getResult', { theme_id: id })
          .then((res) => {
            res = res.data
            if (res.code == 200) {
              this.cardData.themes[index].resultList = res.data
              this.resultData = res.data
              this.isResultType = false
              this.showResult = true
              this.readDraw(id, res.data)
            } else {
              this.$toast(res.msg)
            }
          })
      }
    },
    readDraw(themeId, list) {
      console.log(list)
      let str = list
        .map((item) => {
          return item.result_id
        })
        .join(',')
      this.$http
        .getApp('api/v1/LotteryActivity/hasRead', {
          theme_id: themeId,
          result_ids: str
        })
        .then((res) => {})
    },
    bindDraw() {
      if (!this.isApp) {
        return
      }
      if (this.cardData.used_times >= this.cardData.max_times) {
        this.showShareToast = true
      } else if (
        this.cardData.used_times >= this.cardData.get_times &&
        this.cardData.used_times < this.cardData.max_times
      ) {
        this.showShareToast = true
      } else {
        let promise1 = this.$refs.drawAnimate.draw()
        this.loadingResult = true
        let promise2 = this.$http.postApp('api/v1/LotteryActivity/draw', {})
        Promise.all([promise1, promise2])
          .then((arr) => {
            let res = arr[1]
            res = res.data
            if (res.code == 200) {
              res.data.result_id = res.data.id
              this.$refs.drawAnimate
                .result()
                .then(() => {
                  this.resultData = [res.data]
                  this.resultIndex = this.cardData.themes.findIndex((item) => {
                    return item.theme_id == res.data.theme_id
                  })
                  this.cardData.used_times++
                  if (
                    this.cardData.themes[this.resultIndex].resultList &&
                    this.cardData.themes[this.resultIndex].resultList.length
                  ) {
                    this.cardData.themes[this.resultIndex].resultList.push(
                      res.data
                    )
                  }
                  this.notRead = res.data.not_reads?.find((item) => {
                    return item.theme_id == res.data.theme_id
                  })
                  this.isResultType = true
                  this.showResult = true
                })
                .finally(() => {
                  this.loadingResult = false
                })
            } else {
              this.$toast(res.msg)
              this.loadingResult = false
            }
          })
          .catch(() => {
            this.loadingResult = false
          })
          .finally(() => {})
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.draw {
  min-height: 100vh;
  position: relative;
  background-color: rgb(189, 255, 255);
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b13bc6eea563d0aebe8c9b4a9e2536f0.png');
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center top;

  .bg-desc {
    position: absolute;
    width: 256px;
    left: 50%;
    top: 180px;
    transform: translate(-50%, 0%);
    font-size: 14px;
    font-family: MiSans-Demibold, MiSans;
    font-weight: 600;
    color: #605989;
    line-height: 19px;
    display: flex;
    align-items: center;
    white-space: nowrap;
  }

  .bg-desc::before,
  .bg-desc::after {
    content: '';
    display: inline-block;
    width: 38px;
    height: 1px;
    background-color: #605989;
    margin: 0 3px;
  }

  .loading {
    .draw-animate {
      position: absolute;
      left: 50%;
      top: 45%;
      transform: translate(-50%, -50%);
      width: 300px;
      height: 300px;
    }
  }

  .app-logo {
    margin-top: 34px;
    margin-left: 26px;
    height: 12px;
  }

  .btn-list {
    position: fixed;
    right: 0;
    top: 60px;
    display: flex;
    flex-direction: column;
    z-index: 0;

    .btn-item {
      text-align: center;
      margin-bottom: 5px;
      width: 56px;
      height: 24px;
      background: linear-gradient(180deg, #ffe5ee 0%, #ffcefe 100%);
      border-radius: 13px 0px 0px 13px;
      font-size: 12px;
      font-family: MiSans-Medium, MiSans;
      font-weight: 500;
      color: #605989;
      line-height: 24px;

      .iconfont {
        margin-right: 2px;
      }
    }
  }

  .draw-content {
    margin-top: 491px;
    margin-bottom: 18px;
    text-align: center;

    .draw-btn {
      position: relative;
      z-index: 1;
      margin: 0 auto;
      width: 195px;
      height: 60px;

      .draw-text {
        white-space: nowrap;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        font-size: 22px;
        font-family: MiSans-Demibold, MiSans;
        font-weight: 600;
        color: #ffffff;
        line-height: 29px;
        text-shadow: 0px 2px 1px rgba(59, 66, 225, 0.5);
      }

      .draw-count {
        background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/798df4545e5d08785ab6e299d77a95a1.png');
        background-repeat: no-repeat;
        background-size: 100%;
        width: 116px;
        height: 35px;
        position: absolute;
        left: 50%;
        top: 0;
        transform: translate(-50%, -50%);

        .draw-count-text {
          width: 100%;
          position: absolute;
          left: 50%;
          bottom: 20%;
          transform: translate(-50%, -50%);
          font-size: 12px;
          font-family: MiSans-Demibold, MiSans;
          font-weight: 600;
          color: #ff5172;
          line-height: 16px;
        }
      }

      .draw-btn-image {
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
        z-index: -1;
      }
    }

    .tip {
      margin-top: 6px;
      font-size: 10px;
      font-family: MiSans-Regular, MiSans;
      font-weight: 400;
      color: #605989;
      line-height: 13px;
    }
  }

  .c-container {
    padding-bottom: 20px;

    .c-title {
      margin-bottom: 10px;
      font-size: 12px;
      font-family: MiSans-Demibold, MiSans;
      font-weight: 600;
      color: #ff5172;
      line-height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;

      .c-dot {
        width: 2px;
        height: 2px;
        background: #ff5172;
        margin: 0 3px;
      }

      .c-line {
        width: 9px;
        height: 1px;
        background-color: #ff5172;
      }
    }
  }

  .app-loading {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .toast-wrapper {
    width: 229px;
    height: 298px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .image {
      width: 271px;
      height: 298px;
    }

    .t-tips {
      width: 100%;
      text-align: center;
      position: absolute;
      top: 60px;
      left: 50%;
      transform: translate(-50%, 0%);

      .t-desc {
        font-size: 12px;
        font-family: MiSans-Regular, MiSans;
        font-weight: 400;
        color: #605989;
        line-height: 21px;
      }

      .t-day {
        font-size: 12px;
        font-family: MiSans-Demibold, MiSans;
        font-weight: 600;
        color: #605989;
        line-height: 21px;

        .color {
          color: rgba(188, 130, 236, 1);
        }
      }
    }

    .t-share-btn {
      position: absolute;
      left: 50%;
      bottom: 20px;
      transform: translate(-50%, 0%);
      background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a360ccf5f388e0399a9dcfadda96be3d.png');
      background-repeat: no-repeat;
      background-size: 100%;
      width: 114px;
      height: 37px;
      text-align: center;
      line-height: 37px;
      font-size: 15px;
      font-family: MiSans-Demibold, MiSans;
      font-weight: 600;
      color: #ffffff;
      text-shadow: 0px 1px 1px rgba(225, 59, 156, 0.5);
    }
  }
}

.download {
  position: sticky;
  width: 100%;
  height: 56px;
  background-color: #fff;
  box-shadow: 0 0.5px 0 #ededed;
  top: 0;
  z-index: 99;
  display: flex;
  align-items: center;
  padding: 0px 15px;
  box-sizing: border-box;

  .logo {
    width: 36px;
    height: 36px;
    margin-right: 10px;
  }

  .center {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;

    .text1 {
      font-size: 15px;
      line-height: 23px;
    }

    .text2 {
      font-size: 12px;
      line-height: 16px;
      color: #999;
    }
  }

  .btn {
    position: relative;
    width: 72px;
    background: linear-gradient(270deg, #6759ff 0%, #8b75ff 100%);
    height: 26px;
    text-align: center;
    border-radius: 13px;
    line-height: 26px;
    font-size: 13px;
    color: #fff;
  }
}
</style>
